// createApiCacheKey.ts

const stableSerialize = (value: unknown): string => {
  if (value === null || typeof value !== 'object') {
    return JSON.stringify(value);
  }

  if (Array.isArray(value)) {
    return `[${value.map(stableSerialize).join(',')}]`;
  }

  const record = value as Record<string, unknown>;

  const properties = Object.keys(record)
    .sort()
    .map((key) => `${JSON.stringify(key)}:${stableSerialize(record[key])}`);

  return `{${properties.join(',')}}`;
};

export const createApiCacheKey = (endpointKey: string, query: unknown): string => {
  return `${endpointKey}:${stableSerialize(query)}`;
};
